import React from "react";
import { Card } from "primereact/card";
import styled from "styled-components";
import { PrimaryButton } from "./Button";

export interface CardProps {
  id?: string;
  content: any;
  config?: any;
  style?: any;
  showArrow?: boolean;
  arrowDown?: any;
  detailContent?: any;
  expanded?: boolean;
  LinkNavigate?: any 
  onExpandDetail?: () => void;
  onClick?: () => void;
}

const ButtonCard = styled.div<{ config: any }>`
  width: 24% !important;
  height: 8rem;
  border-radius: 10px;
  box-shadow: unset;
  background: ${(props) => (props.config.active ? props.config.color : "white")};
  @media (max-width: 965px) {
    width: 100% !important;
    height: 3rem !important;
    margin-bottom: 0.5rem !important;
    .p-card-body {
      height: 3rem !important;
    }
  }
  .p-card-body {
    padding: 0;
    border: ${(props) => (props.config.active ? "none" : "1px solid #e8e8e8")};
    border-radius: 10px;
    height: 8rem;
    cursor: pointer;
  }
  .p-card-content {
    padding: 0;
    color: ${(props) => (props.config.active ? "#FFFFFF" : "#9D9D9D")};
  }
`;

const ButtonCardParent = styled.span`
  a {
    text-decoration:none;
    @media (max-width: 965px) {
      display: flex;
      justify-content: space-between;
    }
    &:link,&:visited,&:active{
      color:inherit
    }
  }
`;

const ButtonCardIcon = styled.div`
  text-align: right;
  padding: 0.5rem;
  @media (max-width: 965px) {
    order: 1;
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;

const ButtonCardContent = styled.div`
  line-height: 24px;
  margin-top: 1rem;
  padding: 0.5rem;
  @media (max-width: 965px) {
    margin-top: 0.5rem;
    display: flex;
  }
`;

const ItalicContent = styled.div`
  text-align: left;
  font: italic normal normal 18px/24px Tib;
  letter-spacing: 0px;
  @media (max-width: 965px) {
    margin-right: 0.2rem;
  }
`;

const BoldContent = styled.div`
  text-align: left;
  font: normal normal bold 21px/24px Tib;
  letter-spacing: 0px;
  @media (max-width: 965px) {
    margin-left: 0.2rem;
  }
`;

const CardPromo = styled(Card)`
  width: 95% !important;
  @media (max-width: 768px) {
    width: 90% !important;
  }
  .p-card-body {
    padding: 0;
  }
  .p-card-content {
    padding: 0;
    color: white;
  }
`;

const BasicCard = styled(Card)`
  .p-card-body {
    padding: 0.9rem !important;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    background: white;
  }
  .p-card-content {
    padding: 0 !important;
    color: #484848;
  }
`;

const Mobile = styled(Card)`
  .p-card-body {
    padding: 1rem;
    border: 1px solid #e8e8e8;
  }
  .p-card-content {
    color: #484848;
    padding: 0;
  }
`;

const ShowArrow = styled.div <{ expanded: boolean }>`
  border-top: solid 1px #e8e8e8;
  text-align: center;
  color: #dd052b;
  cursor: pointer;
  padding-top: 1rem;
  img{
    height:0.7rem;
    transform: ${(props) => (props.expanded ? 'rotate(180deg)' : "")};;
  }
`;

export const CardBasic: React.FC<CardProps> = ({ style, content }) => (
  <BasicCard style={{ ...style, borderRadius: "10px", boxShadow: "unset" }}>
    {content}
  </BasicCard>
);

export const CardButton: React.FC<CardProps> = ({
  id,
  content,
  config,
  LinkNavigate,
}) => (
  <ButtonCard
    className="p-card p-component"
    config={config}
  >
    <div className="p-card-body">
      <div className="p-card-content">
        <ButtonCardParent id={id}>
          <LinkNavigate>
            <ButtonCardIcon>
              <img src={config.active ? config.icon : config.iconAlt} alt="icon" />
            </ButtonCardIcon>
            <ButtonCardContent>
              <ItalicContent>{content[0]}</ItalicContent>
              <BoldContent>{content[1]}</BoldContent>
            </ButtonCardContent>
          </LinkNavigate>
        </ButtonCardParent>
      </div>
    </div>
  </ButtonCard>
);

export const PromoCard: React.FC<CardProps> = ({
  config,
  content,
  onClick,
}) => (
  <CardPromo
    style={{
      background: config.color,
      height: "7rem",
      borderRadius: "10px",
      boxShadow: "unset",
      margin: "0.5rem",
    }}
  >
    <div style={{ padding: "1rem" }}>
      <div style={{ textAlign: "left" }}>
        <img src={config.icon} alt="icon" style={{ width: "1.8rem" }} />
      </div>
      <div
        style={{
          marginTop: ".5rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>{content}</div>
        <PrimaryButton
          color="white"
          text="LA QUIERO!"
          onClick={() => onClick()}
        />
      </div>
    </div>
  </CardPromo>
);

export const TableMobile: React.FC<CardProps> = ({
  style,
  content,
  showArrow,
  detailContent,
  expanded,
  arrowDown,
  onExpandDetail,
}) => (
  <Mobile style={{ ...style, boxShadow: "unset" }}>
    {content}
    {showArrow ? (
      <>
        <ShowArrow data-testid="arrow-detail" expanded={expanded} onClick={() => onExpandDetail()}>
          <img src={arrowDown} />
        </ShowArrow>
        {expanded ? detailContent : null}
      </>
    ) : null}
  </Mobile>
);
